export default __webpack_public_path__ + "static/media/surfing_light.7738680a.svg";